<template>
	<div class="recruitment-dashboard">
		<!-- 頂部標題欄 -->
		<div class="page-title u-flex">
			<div>
				<div class="page-title-main">人氣趨勢追蹤</div>
				<div class="page-title-sub">大學問總管理中心</div>
			</div>
			<div class="u-flex page-title-btn" style="color: #999999;">
				<div>數據更新：每月 <span style="color: #ED6D00;">1</span> 日</div>
				<div class="btn-down" @click="dialogVisible=true">
					<img src="@/assets/ic-d.png" style="width:0.16rem;height: 0.16rem;margin-right: 0.05rem;" />
					下載數據報告
				</div>
			</div>
		</div>

		<!-- 日期選擇區域 -->
		<section class="date-section">
			<div class="search-title">
				<img style="margin-right: 0.06rem;" src="@/assets/ic-title.png" />競爭趨勢分析篩選器
			</div>
			<div class="date-container">


				<div class="date-input-group">
					<label class="date-label"><img class="input-icon" style="margin-right: 0.02rem;"
							src="@/assets/ic-1.png" />選擇學校類型</label>

					<el-select clearable placeholder=" " @change="changeSchoolType" filterable
						class="input-date input-date1" v-model="search.type">

						<el-option v-for="(item,index) in schoolType" :key="item" :label="item" :value="item">
						</el-option>

					</el-select>
				</div>
				<div class="date-input-group">
					<label class="date-label"><img class="input-icon" style="margin-right: 0.02rem;"
							src="@/assets/ic-2.png" />選擇大學學群/技職群類</label>

					<el-select @change="changeSchoolGroup" clearable placeholder=" " filterable
						class="input-date input-date1" v-model="search.schoolGroup">

						<el-option v-for="(item,index) in schoolGroup" :key="item" :label="item" :value="item">
						</el-option>

					</el-select>
				</div>
				<div class="date-input-group">
					<label class="date-label"><img class="input-icon" style="margin-right: 0.02rem;"
							src="@/assets/ic-2.png" />選擇學類</label>

					<el-select @change="changeSchoolCategory" clearable placeholder=" " filterable
						class="input-date input-date1" v-model="search.schoolCategory">

						<el-option v-for="(item,index) in schoolCategory" :key="item" :label="item" :value="item">
						</el-option>

					</el-select>
				</div>
				<div class="date-input-group">
					<label class="date-label"><img class="input-icon" style="margin-right: 0.02rem;"
							src="@/assets/ic-2.png" />選擇競爭者</label>

					<el-select collapse-tags @change="initData" multiple clearable placeholder=" " filterable
						class="input-date input-date1" v-model="search.schoolName">

						<el-option v-for="(item,index) in school" :key="item" :label="item" :value="item">
						</el-option>

					</el-select>
				</div>
			</div>

			<div class="module-show" v-if="search.schoolName && search.schoolName.length>0">
				已選競爭者:{{String(search.schoolName)}}
			</div>
		</section>

		<section class="modle-block2">
			<!-- 核心數據指標 -->
			<section class="kpi-section">
				<h2 class="section-title">
					<div class="u-flex">
						<img style="margin-right: 0.06rem;" src="@/assets/ic-title.png" />
						趨勢摘要
					</div>
					<!-- <span class="tips1">請選擇時間範圍和競爭者以查看趨勢摘要</span> -->
				</h2>
				<div class="kpi-grid">
					<div class="kpi-card">
						<img class="ic-block" src="@/assets/block2.png" />
						<div class="kpi-header">
							<span class="kpi-name">
								{{(search.schoolName && search.schoolName.length>0)?search.schoolName[0]:'本站'}}平均捲動深度</span>
						</div>
						<div class="kpi-content">
							<div class="kpi-value">{{qszyData.schoolDepth || 0}}%</div>
							<div class="kpi-comparison positive">
								<span class="trend-icon">↑</span>
								<span class="period">領先市場</span>
								<span class="percentage">{{(qszyData.schoolDepth-qszyData.avgDepth).toFixed(2)}}%</span>
							</div>
						</div>
					</div>

					<div class="kpi-card">
						<img class="ic-block" src="@/assets/block3.png" />
						<div class="kpi-header">
							<span class="kpi-name">市場平均捲動深度</span>
						</div>
						<div class="kpi-content">
							<div class="kpi-value">{{qszyData.avgDepth || 0}}%</div>
							<div class="kpi-comparison positive">
								<span class="period">（基準線）</span>
							</div>
						</div>
					</div>



				</div>


				<div style="margin-top:0.36rem">
					<h2 class="section-title u-flex" style="justify-content: flex-start;">

						<img style="margin-right: 0.06rem;"
							src="@/assets/ic-title.png" />{{search.schoolCategory || ''}}學類點閱趨勢分析
					</h2>

					<div id="one"></div>
				</div>
			</section>

			<!-- 中間內容區域 -->

		</section>

		<div class="era-content-grid">
			<!-- 左侧排行榜 -->
			<section class="era-ranking-section">
				<div class="era-section-header">
					<h2 class="era-section-title u-flex"><img style="margin-right: 0.06rem;"
							src="@/assets/ic-title.png" />{{search.schoolCategory || ''}}學類排行
						<!-- <span class="tips u-flex"><img
								src="@/assets/ic-time.png" />數據區間：2025/07/20 ~ 2025/10/20</span> -->
					</h2>
				</div>

				<div class="date-container">

					<div class="date-input-group">
						<label class="date-label">月份</label>

						<el-date-picker :picker-options="pickerOptions" type="month" value-format="yyyy-MM"
							class="input-date" clearable @change="getRank" v-model="searchRank.yearMonth"
							placeholder="">
						</el-date-picker>
					</div>
					<div class="date-input-group">
						<label class="date-label">學校類別</label>

						<el-select @change="getRank()" clearable placeholder=" " filterable
							class="input-date input-date1" v-model="searchRank.schoolType">

							<el-option v-for="(item,index) in schoolType" :key="item" :label="item" :value="item">
							</el-option>

						</el-select>
					</div>
					<div class="date-input-group">
						<label class="date-label">排名依據</label>

						<el-select placeholder="" @change="getRank()" class="input-date" v-model="searchRank.orderBy">

							<el-option label="瀏覽數" value="1">
							</el-option>
							<el-option label="成長率" value="2">
							</el-option>
							<el-option label="平均停留時間" value="3">
							</el-option>
							<el-option label="平均捲動深度" value="4">
							</el-option>

						</el-select>
					</div>
				</div>
				<!-- <div class="era-search u-flex">
					<div class="u-flex era-search-btn">
						<span class="btn btn1">市場人氣排行（點閱數）</span>
						<span class="btn btn2">本校内容品質優势（滚動深度）</span>
					</div>
					<div class="search-tab u-flex">
						<div class="item on">全部</div>
						<div class="item">僅看普大</div>
						<div class="item">僅看科大</div>
					</div>
				</div> -->

				<div class="era-table-container">
					<div class="ranking-table" style="min-width: 8rem;">
						<div class="table-header">
							<span>排名</span>
							<span>類別</span>
							<span>校名</span>
							<span>系名</span>
							<span>瀏覽數</span>
							<span>成長率</span>
							<span>平均停留時間</span>
							<span>平均捲動深度</span>
						</div>
						<div class="table-row" v-for="(item,index) in dataList" :key="item.rank">
							<span>{{item.indexNo}}</span>
							<span>{{item.schoolType}}</span>
							<span>{{item.schoolName}}</span>
							<span>{{item.departmentName}}</span>
							<span>{{item.visitCount}}</span>
							<span>{{item.visitRate}}</span>
							<span>{{item.avgTime}}</span>
							<span>{{item.avgDepth}}</span>
						</div>
					</div>
				</div>

				<div class="era-search u-flex" style="justify-content: center;margin-top: 0.2rem;">
					<el-pagination @current-change="currentChange" background layout="prev, pager, next"
						:total="dataTotal">
					</el-pagination>
					<!-- <div class="u-flex era-search-btn">
						<span class="btn btn3">快速篩選：內容品質警示（2 筆）</span>
						<span class="btn btn1">查看所有科系（已顯示 5/9）</span>
					</div> -->
				</div>
			</section>

			<!-- 右侧数据面板 -->

		</div>

		<el-dialog title="下載數據報告" :close-on-click-modal="false" :visible.sync="dialogVisible" class="dialog-down">
		
			<div class="date-container">
				<div class="date-input-group">
					<label class="date-label">報告類型</label>
		
					<el-select clearable placeholder=" " filterable class="input-date input-date1"
						v-model="searchDown.statType">
		
						<el-option v-for="(item,index) in statTypeList" :key="item.id" :label="item.name"
							:value="item.id">
						</el-option>
		
					</el-select>
				</div>
			</div>
			<div class="date-container" style="display: block;" v-if="searchDown.statType">
				<div class="date-input-group" style="margin-top: 0.15rem;">
					<label class="date-label"><img class="input-icon" style="margin-right: 0.02rem;"
							src="@/assets/ic-1.png" />選擇學校</label>
		
					<el-select clearable placeholder=" " filterable class="input-date input-date1"
						v-model="searchDown.schoolName">
		<el-option  label="全部"
			value="">
		</el-option>
						<el-option v-for="(item,index) in schoolList" :key="item.name" :label="item.name"
							:value="item.name">
						</el-option>
		
					</el-select>
				</div>
		
				<div class="date-input-group" style="margin-top: 0.15rem;"
					v-if="searchDown.statType==3 || searchDown.statType==5">
					
					<label class="date-label"><img class="input-icon" style="margin-right: 0.02rem;"
							src="@/assets/ic-date.png" />年份</label>
					
					<el-select clearable placeholder=" " filterable class="input-date input-date1"
						v-model="searchDown.statYear">
					
						<el-option v-for="(item,index) in yearList" :key="item" :label="item"
							:value="item">
						</el-option>
					
					</el-select>
				</div>
				<div v-else>
					<div class="date-input-group" style="margin-top: 0.15rem;">
						
						<label class="date-label"><img class="input-icon" style="margin-right: 0.02rem;"
								src="@/assets/ic-date.png" />月份</label>
						
						<el-date-picker :picker-options="pickerOptionsDown" type="month" value-format="yyyy-MM"
							class="input-date" clearable v-model="searchDown.yearMonth" placeholder="年/月">
						</el-date-picker>
					</div>
					<!-- <div class="date-input-group" style="margin-top: 0.15rem;"
						v-if="searchDown.statYear && ( searchDown.statType!=5 &&  searchDown.statType!=3)">
						<label class="date-label"><img class="input-icon" style="margin-right: 0.02rem;"
								src="@/assets/ic-date.png" />月份</label>
		
						<el-date-picker :picker-options="pickerOptions" type="month" format="MM" value-format="MM"
							class="input-date" :default-value="searchDown.statYear" popper-class="month-only-picker"
							clearable v-model="searchDown.statMonth" placeholder="月">
						</el-date-picker>
					</div> -->
				</div>
		
		
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button size="medium" @click="dialogVisible = false">取 消</el-button>
				<el-button size="medium" type="primary" @click="toDown">確認下載</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		apiBaseUrl
	} from '@/api/config.js';
	export default {
		name: 'RecruitmentDashboard',
		data() {
			return {
				dialogVisible: false,
				
				statTypeList: [{
					name: "學校年統計",
					id: '3',
				}, {
					name: "學校月統計",
					id: '4',
				}, {
					name: "學系年統計",
					id: '5',
				}, {
					name: "學系月統計",
					id: '6',
				}],
				yearList:[],
				pickerOptionsDown: {
					disabledDate: (time) => {
						const date = time;
						  const current = new Date();
						
						  // 最小日期为2025年11月1日
						  const minDate = new Date(2025, 10, 1);
						  minDate.setHours(0, 0, 0, 0);
						
						  // 最大日期为上个月的最后一天
						  // current.getMonth() 是当前月份(0-11)，上个月就是 current.getMonth()
						  // 因为 new Date(year, month, 0) 会返回上个月的最后一天
						  const maxDate = new Date(current.getFullYear(), current.getMonth(), 0);
						  maxDate.setHours(23, 59, 59, 999);
						
						  console.log('当前月份:', current);
						  console.log('最大可选日期:', maxDate);
						
						  return date.getTime() < minDate.getTime() || date.getTime() > maxDate.getTime();
					}
				},
				searchDown: {
					statYear: '',
					statMonth: '',
					yearMonth: '',
					schoolName: ''
				},
				search: {
					startDate: '',
					endDate: '',
					schoolName: '',
					type: '',
					schoolGroup: '',
					schoolCategory: '',
					schoolName: []
				},

				pickerOptions: {
					disabledDate: (time) => {
						const date = time;
						const current = new Date();

						// 设置最小日期为2025年11月1日
						const minDate = new Date(2025, 10, 1);

						// 设置最大日期为当前月份的最后一天
						const maxDate = new Date(current.getFullYear(), current.getMonth() + 1, 0);

						return date < minDate || date > maxDate;
					}
				},
				searchRank: {
					yearMonth: ''
				},
				speSearch: {},
				qszyData: {},
				xlqsfxData: {},
				dataTotal: 0,
				dataList: [],
				hasValidRole:false,
				schoolType: [],
				schoolGroup: [],
				schoolCategory: [],
				school: [],
				colorAttr: ['#0BA29B', '#FABD00', '#8CC8CC'],
			}
		},
		created() {
			this.$nextTick(() => {
				const now = new Date();
				const year = now.getFullYear();
				const month = String(now.getMonth() + 1).padStart(2, '0'); // 补零，如：01, 02
				// 下载年份选择
				const startYear = 2025;
				const endYear = year - 1; // 去年
				
				this.yearList = [];
				for (let year = startYear; year <= endYear; year++) {
				  this.yearList.push(year.toString());
				}
				this.searchRank.yearMonth = `${year}-${month}`
				this.getOptions()
				this.initData()

				this.$axios
					.post("rest-api/system/app/user/getInfo")
					.then((res) => {
						if (res.code == 200) {
							// 判断是否包含任意一个指定角色代码
							if (res.data.user && res.data.user.roles) {

								this.hasValidRole = res.data.user.roles.some(item => ['A01', 'B01', 'C01',
									'D01'
								].includes(item.roleKey));
							}
						}
					})
					.catch((err) => {});
				this.$axios
					.post("rest-api/system/app/school/list")
					.then((res) => {

						this.schoolList = res.data
						this.initData()
					})
					.catch((err) => {});
			})
		},

		methods: {

			toDown() {

				if (!this.searchDown.statType) {

					this.$message({
						message: '請選擇報告類型',
						type: 'warning'
					});
					return
				}
				if (!this.hasValidRole && !this.searchDown.schoolName) {

					this.$message({
						message: '請選擇學校',
						type: 'warning'
					});
					return
				}
				this.$loading()
				this.$axios
					.post("rest-api/system/app/bigQuery/export/data", {
						...this.searchDown
					})
					.then((res) => {

						this.$loading().close()
						this.dialogVisible = false
						window.open(res.data, '_blank');
					})
					.catch((err) => {

						this.$loading().close()
					});

			},
			changeSchoolType(e) {
				this.$axios
					.post("rest-api/system/app/user/rq/schoolGroup/list", {
						type: e
					})
					.then((res) => {
						this.schoolGroup = res.data
						this.schoolCategory = []
						this.school = []
						this.search.schoolGroup = ''
						this.search.schoolCategory = ''
						this.search.schoolName = []
					})
					.catch((err) => {});
			},

			changeSchoolGroup(e) {
				this.$axios
					.post("rest-api/system/app/user/rq/schoolCategory/list", {
						schoolGroup: e,
						type: this.search.type
					})
					.then((res) => {

						this.schoolCategory = res.data
						this.school = []
						this.search.schoolCategory = ''
						this.search.schoolName = []
					})
					.catch((err) => {});
			},

			// changeInit(value){
			// 	  // 如果选择了超过4个
			// 	      if (value.length > 4) {
			// 	        this.$message.warning('最多只能选择4个学校')
			// 	        // 保留前4个选项
			// 	        this.search.schoolName = value.slice(0, 4)
			// 	      } else {
			// 	        // 正常情况，调用原来的 initData
			// 	        this.initData()
			// 	      }
			// },

			changeSchoolCategory(e) {
				this.$axios
					.post("rest-api/system/app/user/rq/school/list", {
						schoolGroup: this.search.schoolGroup,
						type: this.search.type,
						schoolCategory: e
					})
					.then((res) => {

						this.school = res.data
						this.search.schoolName = []
						this.initData()
					})
					.catch((err) => {});
			},
			getOptions() {

				this.$axios
					.post("rest-api/system/app/user/rq/schoolType/list")
					.then((res) => {
						this.schoolType = res.data
					})
					.catch((err) => {});

			},
			initData() {



				let speSearch = JSON.parse(JSON.stringify(this.search))
				this.speSearch = JSON.parse(JSON.stringify(this.search))
				if (this.search.schoolName && this.search.schoolName.length > 0) {
					speSearch.schoolName = this.search.schoolName[0]
					this.speSearch.schoolName = String(this.search.schoolName)
				}
				this.getRank()
				this.$axios
					.post("rest-api/system/app/bigQuery/qszy/data", speSearch)
					.then((res) => {
						this.qszyData = res.data
					})
					.catch((err) => {});
				if (this.search.schoolName && this.search.schoolName.length > 0) {

					this.$axios
						.post("rest-api/system/app/bigQuery/xlqsfx/data", this.speSearch)
						.then((res) => {
							this.xlqsfxData = res.data
							console.log(this.formatLineChartData(res.data), 1111111111)
							this.initCharT(this.formatLineChartData(res.data))
						})
						.catch((err) => {});
				} else {

					this.xlqsfxData = []
					this.initCharT([])
				}


			},
			formatLineChartData(data) {
				// 提取所有月份（去重并按时间排序）
				const months = [...new Set(data.map(item => item.month))]
					.sort((a, b) => {
						// 按statMonth排序以确保时间顺序
						const monthA = data.find(item => item.month === a).statMonth;
						const monthB = data.find(item => item.month === b).statMonth;
						return monthA - monthB;
					});

				// 提取所有学校（去重）
				const schools = [...new Set(data.map(item => item.schoolName))];
				// 为每个学校创建数据系列
				const series = []
				schools.some((school, index) => {
					// 为该校提取每个月份的数据
					const schoolData = months.map(month => {
						const record = data.find(item =>
							item.month === month && item.schoolName === school
						);
						return record ? record.visitCount : 0;
					});
					console.log(schoolData, 111111111111)
					let itemData = {
						name: school,
						data: schoolData,
						type: 'line',
						smooth: true,
						lineStyle: {
							width: 1,
							color: this.colorAttr[index]
						},
						symbol: 'circle',
						symbolSize: 8,
						itemStyle: {
							color: this.colorAttr[index]
						},
						emphasis: {
							focus: 'series'
						}
					}
					series.push(itemData)
				});

				return {
					school: schools,
					months: months,
					series: series,
					// 包含原始数据供参考
					rawData: data
				};
			},

			initCharT(res) {
				console.log(res, 11111111111)
				const option = {
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'cross',
							label: {
								backgroundColor: '#6a7985'
							}
						}
					},
					legend: {
						data: res.school,
						bottom: 4,
						textStyle: {
							fontSize: 10
						}
					},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '15%',
						top: '15%',
						containLabel: true
					},
					xAxis: {
						type: 'category',
						boundaryGap: false,
						data: res.months,
						textStyle: {
							fontSize: 10
						},
						axisLine: {
							lineStyle: {
								color: '#999'
							},
							textStyle: {
								fontSize: 10
							}
						}
					},
					yAxis: {
						type: 'value',
						// min: 14000,
						// max: 24000,
						// interval: 2000,
						// axisLabel: {
						// 	formatter: function(value) {
						// 		return value.toLocaleString();
						// 	}
						// },
						axisLine: {
							lineStyle: {
								color: '#999'
							}
						},
						splitLine: {
							lineStyle: {
								color: '#eee',
								type: 'dashed'
							}
						}
					},
					series: res.series,
				};
				var myChartTwo = this.$echarts.init(document.getElementById("one")); //图标初始化\
				myChartTwo.setOption(option, true);
				window.onresize = function() {
					myChartTwo.resize();
				};
			},
			getChannelClass(channel) {
				const classMap = {
					'Organic Search': 'organic',
					'Referral': 'referral',
					'Social Media': 'social',
					'Paid Search': 'paid',
					'Direct': 'direct'
				}
				return classMap[channel] || 'organic'
			},

			currentChange(e) {

				this.page = e
				this.getList()
			},
			getRank() {

				this.page = 1
				this.getList()
			},
			getList() {

				this.$loading()
				const that = this;
				let search = JSON.parse(JSON.stringify(that.speSearch))
				search.schoolName = ''
				that.$axios
					.post("rest-api/system/app/bigQuery/xlphb/data", {
						pageNo: that.page,
						...search,
						...that.searchRank
					})
					.then((res) => {
						this.$loading().close()
						that.dataList = res.data.list
						that.dataTotal = res.data.total
					})
					.catch((err) => {});
			},
		}
	}
</script>

<style scoped lang="scss">
	.recruitment-dashboard {
		min-height: 100vh;
		background: #EEF3F6;
		padding: 0.2rem;
	}

	/* 頂部標題欄 */
	.dashboard-header {
		background: rgba(255, 255, 255, 0.95);
		border-radius: 0.12rem;
		padding: 0.2rem;
		margin-bottom: 0.2rem;
		box-shadow: 0 0.04rem 0.2rem rgba(0, 0, 0, 0.1);
	}

	.header-content {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.page-title {}

	.help-btn {
		background: #4a5568;
		color: white;
		border: none;
		padding: 0.08rem 0.2rem;
		border-radius: 0.06rem;
		font-size: 0.2rem;
		cursor: pointer;
	}

	/* 日期選擇區域 */
	.date-section {
		background: rgba(255, 255, 255, 0.95);
		border-radius: 0.12rem;
		padding: 0.2rem;
		margin-bottom: 0.2rem;
	}

	.date-container {
		display: flex;
		gap: 0.2rem;
	}

	.date-input-group {
		flex: 1;
	}

	.date-label {
		display: flex;
		align-items: center;
		margin-bottom: 0.08rem;
		color: #222;
		font-size: 0.18rem;
	}

	.date-input {
		background: #91A2A41A;
		border: 0.01rem solid #91A2A480;
		border-radius: 0.08rem;
		font-size: 0.2rem;
		padding: 0.12rem 0.1rem;
		color: #999;
	}

	/* 核心數據指標 */
	.kpi-section {
		flex: 1;
		margin-right: 0.1rem;
		background: rgba(255, 255, 255, 0.95);
		border-radius: 0.12rem;
		padding: 0.2rem;
	}

	.section-title {
		font-size: 0.2rem;
		font-weight: bold;
		margin-bottom: 0.2rem;
		justify-content: space-between;
		display: flex;
		align-items: center;
		color: #2d3748;
	}

	.kpi-grid {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(1.8rem, 1fr));
		gap: 0.2rem;
	}

	.kpi-card {
		background: white;
		position: relative;
		border-radius: 0.12rem;
		padding: 0.25rem;
		box-shadow: 0.04rem 0.04rem 0.2rem 0rem #27545726;

		.ic-block {
			width: 0.5rem;
			height: 0.5rem;
			position: absolute;
			top: 0.25rem;
			right: 0.25rem
		}
	}

	.kpi-header {
		margin-bottom: 00.17rem;
	}

	.kpi-name {
		font-size: 0.18rem;
		color: #777;
	}

	.kpi-value {
		font-size: 0.32rem;
		color: #000;
		margin-bottom: 0.4rem;
	}

	.kpi-comparison {
		display: flex;
		align-items: center;
		gap: 0.06rem;
		font-size: 0.12rem;
	}

	.kpi-comparison.positive {
		color: #21C93A;
	}

	.trend-icon {
		font-weight: bold;
	}

	/* 主要內容區域 */
	.main-content {
		flex: 1;
		margin-left: 0.1rem;
		background: rgba(255, 255, 255, 0.95);
		border-radius: 0.12rem;
		padding: 0.2rem;
	}

	.content-grid {
		display: grid;
		grid-template-columns: 2fr 1fr;
		gap: 0.3rem;
	}

	/* 排行榜樣式 */
	.ranking-section {
		flex: 1;
		margin-left: 0.1rem;
		background: white;
		border-radius: 0.12rem;
		padding: 0.2rem;
		box-shadow: 0 0.02rem 0.1rem rgba(0, 0, 0, 0.05);
	}

	.ranking-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 0.1rem;
	}

	.ranking-title {
		font-size: 0.2rem;
		font-weight: bold;
		color: #2d3748;
		margin-bottom: 0.2rem;
	}

	.ranking-table {
		border: 0.01rem solid #27545726;
		border-radius: 0.1rem;
		margin-top: 0.2rem;
		overflow: hidden;
	}

	.ranking-date {
		color: #718096;
		font-size: 0.2rem;
	}

	.ranking-subtitle {
		color: #718096;
		font-size: 0.2rem;
		margin-bottom: 0.2rem;
	}

	.table-header {
		display: flex;
		padding: 0.12rem 0;
		font-size: 0.18rem;
		border-bottom: 0.01rem solid #e2e8f0;
		background: #0BA29B0F;
		color: #4a5568;
	}

	.table-header span {
		flex: 1;
		text-align: center;
	}

	.table-row span {
		flex: 1;
		text-align: center;
	}

	.table-row {
		display: flex;
		font-size: 0.18rem;
		padding: 0.12rem 0;
		border-bottom: 0.01rem solid #e2e8f0;
	}

	.rank {
		color: #4a5568;
	}

	.department {
		color: #2d3748;
	}

	.area,
	.rate {
		text-align: right;
		color: #4a5568;
	}

	/* 篩選區域樣式 */
	.filter-section {
		background: white;
		border-radius: 0.12rem;
		padding: 0.2rem;
		box-shadow: 0 0.02rem 0.1rem rgba(0, 0, 0, 0.05);
	}

	.filter-group {
		display: flex;
		gap: 0.1rem;
		margin-bottom: 0.2rem;
	}

	.filter-btn {
		flex: 1;
		padding: 0.1rem;
		border: 0.01rem solid #e2e8f0;
		background: #f7fafc;
		border-radius: 0.08rem;
		cursor: pointer;
		transition: all 0.3s;
	}

	.filter-btn.active {
		background: #667eea;
		color: white;
		border-color: #667eea;
	}

	.primary-btn {
		width: 100%;
		padding: 0.12rem;
		background: #667eea;
		color: white;
		border: none;
		border-radius: 0.08rem;
		font-size: 0.2rem;
		cursor: pointer;
		margin-bottom: 0.2rem;
	}

	.dropdown {
		width: 100%;
		padding: 0.12rem;
		border: 0.01rem solid #e2e8f0;
		border-radius: 0.08rem;
		background: white;
		margin-bottom: 0.2rem;
	}

	.stats-info {
		display: flex;
		flex-direction: column;
		gap: 0.12rem;
	}

	.stat-item {
		padding: 0.1rem;
		background: #f7fafc;
		border-radius: 0.06rem;
		text-align: center;
		color: #718096;
		font-size: 0.2rem;
	}

	/* 響應式設計 */
	@media (max-width: 1024px) {
		.content-grid {
			grid-template-columns: 1fr;
			gap: 0.2rem;
		}
	}

	@media (max-width: 768px) {
		.recruitment-dashboard {
			padding: 0.1rem;
		}

		.header-content {
			flex-direction: column;
			gap: 00.17rem;
			align-items: flex-start;
		}

		.date-container {
			flex-direction: column;
			gap: 00.17rem;
		}

		.kpi-grid {
			grid-template-columns: 1fr;
		}

		.table-header,
		.table-row {
			grid-template-columns: 0.5rem 1fr 0.8rem 0.7rem;
			gap: 0.1rem;
		}

		.filter-group {
			flex-direction: column;
		}
	}

	@media (max-width: 480px) {
		.kpi-value {
			font-size: 0.24rem;
		}

		.table-header,
		.table-row {
			grid-template-columns: 0.4rem 1fr 0.7rem 0.6rem;
			gap: 0.08rem;
		}

		.ranking-header {
			flex-direction: column;
			align-items: flex-start;
			gap: 0.1rem;
		}
	}

	.search-title {
		font-weight: bold;
		display: flex;
		align-items: center;
		margin-bottom: 0.28rem;
	}

	.modle-block2 {
		display: flex;
	}

	@media (max-width: 1024px) {
		.modle-block2 {
			display: block;
		}

		.kpi-section {
			margin-right: 0;

			.section-title {
				display: block;

				.tips1 {
					display: block;
					margin-top: 0.1rem;
				}
			}
		}

		.ranking-section {
			margin-left: 0;
		}
	}

	/* 页面标题 */
	.era-header {
		margin-bottom: 0.3rem;
	}

	.era-main-title {
		font-size: 0.28rem;
		font-weight: 700;
		color: #2d3748;
		text-align: center;
	}

	/* 内容网格布局 */
	.era-content-grid {
		display: grid;
		// grid-template-columns: 2fr 1fr;
		gap: 0.3rem;
		margin: 0 auto;
	}

	/* 排行榜区域 */
	.era-ranking-section {}

	.era-section-header {}

	.era-section-title {
		font-size: 0.2rem;
		font-weight: bold;
		color: #2d3748;

		.tips {
			font-weight: normal;
			font-size: 0.12rem;
			color: #ED6D00;
			margin-left: 0.3rem;
		}

		img {
			width: 0.2rem;
			height: 0.2rem;
			margin-right: 0.06rem;
		}
	}

	.era-section-title-sub {
		font-size: 0.2rem;
		font-weight: bold;
		color: #0BA29B;
		margin-bottom: 0.2rem;
		margin-top: 0.2rem;
	}

	/* 表格样式 */
	.era-table-container {
		overflow-x: auto;
	}

	.era-ranking-table {
		width: 100%;
		border-collapse: collapse;
		font-size: 0.2rem;
	}

	.era-ranking-table th {
		background: #f8fafc;
		padding: 0.12rem 0.08rem;
		text-align: left;
		font-weight: bold;
		color: #4a5568;
		border-bottom: 0.02rem solid #e2e8f0;
	}

	.era-ranking-table td {
		padding: 0.12rem 0.08rem;
		border-bottom: 0.01rem solid #e2e8f0;
		color: #4a5568;
	}

	.era-ranking-table .era-highlight-row {
		background: #fffaf0;
	}

	.era-ranking-table .era-highlight-row td {
		font-weight: 500;
	}

	.era-rank-col {
		width: 0.6rem;
	}

	.era-name-col {
		min-width: 2rem;
	}

	.era-private-col {
		width: 1.2rem;
	}

	.era-growth-col {
		width: 1rem;
	}

	.era-school-col {
		width: 1.4rem;
	}

	.era-rank-cell {
		text-align: center;
	}

	.era-rank-number {
		display: inline-block;
		width: 0.28rem;
		height: 0.28rem;
		line-height: 0.28rem;
		text-align: center;
		background: #667eea;
		color: white;
		border-radius: 50%;
		font-size: 0.12rem;
		font-weight: bold;
	}

	.era-ranking-table .era-highlight-row .era-rank-number {
		background: #ed8936;
	}

	.era-name-cell {
		color: #2d3748;
		font-weight: 500;
	}

	.era-growth-cell {
		text-align: center;
	}

	.era-growth-rate.era-positive {
		color: #48bb78;
		font-weight: bold;
	}

	.era-school-cell {
		text-align: right;
	}

	/* 右侧数据面板 */
	.era-stats-panel {
		display: flex;
		flex-direction: column;
		gap: 0.25rem;
		padding-top: 0.4rem;
	}

	.era-chart-section,
	.era-quality-section {
		background: #EEF6F685;
		border-radius: 00.17rem;
		padding: 0 00.17rem 00.17rem;
	}

	.era-chart-title {
		font-size: 0.2rem;
		font-weight: bold;
		color: #2d3748;
		margin-bottom: 0.2rem;
	}

	/* 管道列表 */
	.era-channel-list {
		display: flex;
		flex-direction: column;
		gap: 0.12rem;
	}

	.era-channel-item {
		display: flex;
		align-items: center;
		gap: 0.1rem;
		padding: 0.08rem 0;
	}

	.era-channel-dot {
		width: 0.12rem;
		height: 0.12rem;
		border-radius: 50%;
	}

	.era-channel-dot.era-organic {
		background: #48bb78;
	}

	.era-channel-dot.era-referral {
		background: #ed8936;
	}

	.era-channel-dot.era-social {
		background: #9f7aea;
	}

	.era-channel-dot.era-paid {
		background: #4299e1;
	}

	.era-channel-dot.era-direct {
		background: #f56565;
	}

	.era-channel-name {
		color: #4a5568;
		font-size: 0.2rem;
	}

	/* 品质评比表格 */
	.era-quality-table {
		display: flex;
		flex-direction: column;
		gap: 00.17rem;
	}

	.era-table-header {
		display: grid;
		grid-template-columns: 1fr 1fr 1fr;
		gap: 00.17rem;
		padding-bottom: 0.1rem;
		border-bottom: 0.02rem solid #e2e8f0;
		font-weight: bold;
		color: #4a5568;
		font-size: 0.12rem;
	}

	.era-table-body {
		display: flex;
		flex-direction: column;
		gap: 0.12rem;
	}

	.era-table-row {
		display: grid;
		grid-template-columns: 1fr 1fr 1fr;
		gap: 00.17rem;
		align-items: center;
	}

	.era-channel-cell {
		font-size: 0.12rem;
		color: #4a5568;
		font-weight: 500;
	}

	.era-progress-cell {
		position: relative;
	}

	.era-progress-bar {
		position: relative;
		height: 0.24rem;
		background: #f7fafc;
		border-radius: 0.12rem;
		overflow: hidden;
	}

	.era-progress-fill {
		height: 100%;
		background: linear-gradient(90deg, #667eea, #764ba2);
		border-radius: 0.12rem;
		transition: width 0.3s ease;
	}

	.era-progress-fill.era-depth-fill {
		background: linear-gradient(90deg, #48bb78, #38a169);
	}

	.era-progress-text {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		font-size: 0.11rem;
		font-weight: bold;
		color: #2d3748;
		z-index: 1;
	}

	/* 响应式设计 */
	@media (max-width: 1200px) {
		.era-content-grid {
			grid-template-columns: 1fr;
			gap: 0.2rem;
		}

		.era-stats-panel {
			flex-direction: row;
		}

		.era-stats-panel {
			padding-top: 0;
		}

		.era-chart-section,
		.era-quality-section {
			flex: 1;
		}

		.page-title {
			display: block;

			.page-title-btn {
				display: flex;
				justify-content: space-between;
			}
		}
	}

	@media (max-width: 768px) {
		.era-container {
			padding: 00.17rem;
		}

		.era-section-title {
			display: block;

			.tips {
				margin-left: 0;
				margin-top: 0.17rem;
			}
		}

		.era-main-title {
			font-size: 0.22rem;
		}

		.era-content-grid {
			gap: 00.17rem;
		}

		.era-stats-panel {
			flex-direction: column;
		}

		.era-ranking-table {
			font-size: 0.12rem;
		}

		.era-ranking-table th,
		.era-ranking-table td {
			padding: 0.08rem 0.06rem;
		}

		.era-name-col {
			min-width: 1.5rem;
		}

		.era-private-col {
			width: 1rem;
		}

		.era-growth-col {
			width: 0.8rem;
		}

		.era-school-col {
			width: 1.2rem;
		}
	}

	@media (max-width: 480px) {
		.era-container {
			padding: 0.1rem;
		}

		.era-main-title {
			font-size: 0.2rem;
		}

		.era-section-title {
			font-size: 0.2rem;
		}

		.era-ranking-table {
			font-size: 0.11rem;
		}

		.era-ranking-table th,
		.era-ranking-table td {
			padding: 0.06rem 0.04rem;
		}

		.era-table-header,
		.era-table-row {
			grid-template-columns: 1fr 1fr;
			gap: 0.1rem;
		}

		.era-table-header .era-depth-header,
		.era-table-row .era-progress-cell:last-child {
			display: none;
		}

		.era-rank-number {
			width: 0.24rem;
			height: 0.24rem;
			line-height: 0.24rem;
			font-size: 0.11rem;
		}
	}

	.era-content-grid {
		margin-top: 0.2rem;
		background: white;
		border-radius: 0.12rem;
		padding: 0.2rem;
		box-shadow: 0 0.04rem 0.2rem rgba(0, 0, 0, 0.08);
	}

	.page-title {
		justify-content: space-between;
		margin: 0 0 0.3rem;


		.page-title-main {
			font-size: 0.26rem;
			font-weight: bold;
		}

		.page-title-sub {
			color: #0BA29B;
			font-size: 0.22rem;
			font-weight: bold;
			margin-top: 0.12rem;
		}
	}

	.module-show {
		background: #ED6D001A;
		color: #ED6D00;
		font: size 0.2rem;
		padding: 0.2rem;
		margin-top: 0.3rem
	}

	.tips1 {
		background: #ED6D001A;
		border-radius: 16px;
		font-size: 0.12rem;
		color: #ED6D00;
		padding: 0.08rem 0.2rem;

	}


	#one {
		height: 3.2rem;
	}

	.era-search {
		justify-content: space-between;
		font-size: 0.18rem;

		.btn {
			padding: .12rem;
			border-radius: 6px;
			margin-right: 0.16rem;
			cursor: pointer;
		}

		.btn1 {
			background: #0BA29B;
			color: #fff;
		}

		.btn2 {
			background: #eee;
			color: #999;
			border: 1px solid #ccc
		}

		.btn3 {
			background: #FFB16F;
			color: #fff;
		}

		.search-tab {
			background: #eee;
			color: #4E5969;
			border: 1px solid #ccc;
			border-radius: 6px;
			padding: 0.06rem 0;

			.item {
				padding: 0.06rem 0.12rem;
				border-radius: 6px;
				cursor: pointer;
				margin: 0 0.04rem;

				&:hover {

					color: #0BA29B;
					background: #fff;
				}

				&.on {
					color: #0BA29B;
					background: #fff;
				}

			}

		}
	}


	.dialog-down {
		width: 5rem;
		height: 6rem;
		margin: 0 auto;

		::v-deep .el-dialog {
			width: 100% !important;
			overflow: auto
		}
	}

	@media (max-width: 768px) {

		.dialog-down {
			width: 90% !important;
		}
	}
</style>